<template>
  <div class="join_progress">
    <div class="mobile_device">
      <div v-if="stage === 1" class="progress_wrap">
        <progress max="100" value="25"></progress>
        <span class="current_page">1/4</span>
      </div>
      <div v-if="stage === 2" class="progress_wrap">
        <progress max="100" value="50"></progress>
        <span class="current_page">2/4</span>
      </div>
      <div v-if="stage === 3" class="progress_wrap">
        <progress max="100" value="75"></progress>
        <span class="current_page">3/4</span>
      </div>
      <div v-if="stage === 4" class="progress_wrap">
        <progress max="100" value="100"></progress>
        <span class="current_page">4/4</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'JoinProgress',
  props: {
    stage: {
      type: Number,
      default: 1,
      required: true
    }
  }
}
</script>
<style lang="scss" scoped>
progress {
  display: block;
  width: 100%;
  height: 4px;
  -webkit-appearance: none;
  appearance: none;
}
progress::-webkit-progress-bar {
  background-color: #e8e8e8;
}
progress::-webkit-progress-value {
  background-color: #008df3;
}
.current_page {
  display: block;
  text-align: right;
  margin-top: 8px;
  margin-bottom: 20px;
  font-size: 13px;
  font-family: 'pretendard-medium';
  color: #008df3;
  letter-spacing: 0;
}
</style>
